import React, { useState, FormEvent, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom'
import { API, graphqlOperation } from "aws-amplify";
import AWS from 'aws-sdk';
import PageHeader from '../../components/PageHeader';
import Input from '../../components/Input';

import hello from '../../assets/images/hello.svg';
import overlay from '../../assets/images/overlay.png';

import api from '../../services/api';
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { getUserByCPF } from '../../graphql/queries';

import './styles.css';
import { updateUser } from '../../graphql/mutations';

const IdForm = () => {

  useEffect(()=>{
    console.log(process.env.NODE_ENV)
    console.log(process.env.REACT_APP_AWS_ACCESS_KEY)
  },[])
  

  const {code} = useParams<{ code: string }>();
  const history = useHistory();


  const [document, setDocument] = useState('');
  const [validDocument, setValidDocument] = useState(false);
  const [photo, setPhoto] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<any>(false);
  const [idCode, setIdCode] = useState(code);
  const [user, setUser] = useState<any>();


  async function uploadFile(buffer:any) {

    let current_date = new Date();

    let data2 = buffer.replace(/^data:image\/\w+;base64,/, "");
    var buf = Buffer.from(data2, 'base64');
    var code = current_date.getTime();
    let filename = code+'.png';

    var albumBucketName = "mmspcarteirasstorage34555-staging";
    var bucketRegion = "us-east-1";

    AWS.config = new AWS.Config();
    AWS.config.accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY;
    AWS.config.secretAccessKey = process.env.REACT_APP_AWS_SECRET_KEY

    const params = {
        Bucket: albumBucketName,
        Key: 'photos/'+filename,
        Body: buf
    };
    const s3 = new AWS.S3({ apiVersion: '2006-03-01'});
    const data = await s3.upload(params).promise();
    return data.Location;
}

  async function handleValidateDocument() {
    setLoading(true)
    let cpf = document.replace(/[^a-zA-Z0-9]/g, "");
    
    const apiData: any = await API.graphql(
      graphqlOperation(getUserByCPF, { cpf: cpf })
    );

    let result = apiData.data.userByCpf.items;

    if (result.length > 0) {
   
      console.log(result[0])
      if(result[0].nome) {
        setUser(result[0]);
        setValidDocument(true)
        localStorage.setItem("user", JSON.stringify(result[0]));
      } else {
        alert("Por favor, confira o documento informado e tente novamente.")
      }
      setLoading(false);
    } else {
      alert("Cadastro não encontrado, verifique seu documento por favor.");
      setLoading(false);
    }
  }

  function handleTakePhoto (dataUri:any) {
    setPhoto(dataUri)
  }

  async function handleGenerateID(e: FormEvent) {
    setLoading(true)
    e.preventDefault();

    let final_url = await uploadFile(photo)
    console.log(final_url)
    let metadata = JSON.parse(user.metadata);
    let body = {
      "userName": user.nome,
      "request": {
        "background": "https://mmspcarteirasstorage34555-staging.s3.amazonaws.com/carteira-2023-1-background.png",
        "coordinates":{
          "profile": {
            "axys_y": 360,
            "axys_x": 800,
            "width": 180,
            "height": 205
          },
          "background": {
            "axys_y": 0,
            "axys_x": 0,
            "width": 1147,
            "height": 723
          },
          "name": {
            "font": "bold 33px , sans-serif",
            "color": "#333",
            "width": 600,
            "axys_x": 200,
            "axys_y": 390
          },
          "data": {
            "font": "italic bold 33px , Roboto",
            "color": "#FFF",
            "width": 600,
            "axys_x": 220,
            "axys_y": 422
          }
        },
        "userAttributes": {
          "email": user.email,
          "name": user.nome,
          "whatsapp": user.whatsapp || '',
          "cpf": user.cpf || '',
          "credenciamento": metadata.credencial || '',
          "tecnica":metadata.tecnica || '',
          "photo":final_url
        }
      
      }
    };

    api.post('/', body).then(async (result:any) => {
      setLoading(false);
      let update = await API.graphql(graphqlOperation(updateUser,
          {  input: {id: user.id, photo_url: final_url}}
      ));
      history.push('/carteira/'+result.data.code);
    }).catch(() => {
      setLoading(false)
      alert('Ocorreu um erro na geração da sua carteira, por favor reinicie o processo.');
    })
  }

  function handleResetPhoto() {
    setPhoto('');
    return false;
  }
  let url_carteira = '';
  if(idCode) {
      url_carteira = "https://mmspcarteirasstorage34555-staging.s3.amazonaws.com/carteiras/"+idCode+".png";
  }
  return (
    <div id="page-id-form" className="container">
      <PageHeader 
        title="Carteira do Artesão"
        description="Obtenha aqui sua carteira de identificação do artesão"
        image={hello}
      />
      {!idCode && (
      <main>
          {loading && (

          <fieldset>
            <legend>Aguarde...</legend>
          </fieldset>

        )}
        {message && (

          <fieldset>
            <legend>{message}</legend>
          </fieldset>

        )}
          {!validDocument && !loading && (
            <fieldset>
              <legend>Consulte ou emita sua carteira informando o seu CPF no campo abaixo: </legend>
              <Input 
                name="cpf" 
                label="CPF" 
                value={document}
                placeholder="Sem pontos ou traços"
                onChange={(e) => { setDocument(e.target.value) }}
              />
              <button type="button" onClick={handleValidateDocument}>
                  Prosseguir
              </button>
            </fieldset>
          )}
          
          {validDocument && !loading && user &&  (
          <fieldset style={{maxWidth:'100%'}}>
            <legend>Olá {user.nome.split(' ')[0]}! Vamos tirar uma foto?</legend>
            <p style={{textAlign:'center'}}>Pedimos que tire uma foto do seu rosto bem centralizado no modelo.</p> <br/>

            {photo && (
            <div style={{ position:'relative',boxSizing:'border-box',width:'100%'}}>
              <img src={photo}
                style={{width: '100%'}} />
            </div> )}
            {photo && !loading &&  (
            <div>
              <p>Gostou da foto? Toque em "Salvar Foto" para continuar. Ou tire outra.</p>
              <button type="button" onClick={handleGenerateID}>
                Salvar Foto
              </button>
              <button type="button" style={{backgroundColor:'#666'}} onClick={handleResetPhoto}>
                Tirar outra
              </button>
            </div>
            )
            }

            {!photo && (
            <div style={{ position:'relative',boxSizing:'border-box',width:'100%'}}>
              <img src={overlay}
                style={{position: 'absolute',width: '100%',
                  height: '97%', opacity: 0.5, zIndex: 1}} />
                <Camera 
                onTakePhoto  = {  handleTakePhoto }
                >
              </Camera>
            </div> ) }
          
          </fieldset>
          )}
          <footer>
        
            <p>&copy; Programa Mãos e Mentes SP - Rede Asta</p>
          </footer>
      </main>
      ) }
      {idCode && !loading && (
        <main>
           <fieldset>
             <legend style={{textAlign: 'center'}}>Sua carteira está pronta!😊 <br/> Você pode baixá-la clicando no botão abaixo.</legend>
              <img src={url_carteira} style={{width:'100%'}}></img>
            </fieldset>
            <footer>
          
            <a className="button" href={url_carteira} download="proposed_file_name" style={{width: '100%'}}> Baixar Carteira</a>  
              <p style={{marginTop:20}}>&copy; Programa Mãos e Mentes SP - Rede Asta</p>

          </footer>

        </main>
      )}
    </div>
  )
}

export default IdForm;
